import { withDevtools, withStorageSync } from '@angular-architects/ngrx-toolkit';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

export type ThemeMode = 'light' | 'dark';

interface UiStore {
  sidebarCollapsed: boolean;
  lang: string;
  themeMode: ThemeMode;
}

const initialState: UiStore = {
  sidebarCollapsed: false,
  lang: '',
  themeMode: 'light',
};

export const UiStore = signalStore(
  { providedIn: 'root' },
  withDevtools('ui'),
  withState(initialState),
  withStorageSync({
    key: 'ui',
    select: ({ sidebarCollapsed, lang, themeMode }) => ({ sidebarCollapsed, lang, themeMode }),
  }),
  withMethods((store) => {
    return {
      toggleSidebar() {
        patchState(store, { sidebarCollapsed: !store.sidebarCollapsed() });
      },

      /**
       * Set the language of the application
       *
       * @internal This method should be called only from LanguageService
       *
       * @param code
       */
      setLanguage(code: string) {
        patchState(store, { lang: code });
      },

      /**
       * @internal This method should be called only from ThemeService
       */
      setThemeMode(themeMode: ThemeMode) {
        patchState(store, { themeMode });
      },
    };
  }),
);
